import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useSelector } from "react-redux";

import LoginPage from "./pages/Login/Login";
import Layout from "./Layout";
import { getIsAuthenticated, getAccountType } from "./store/auth/selectors";
import { checkPermission, PERMISSION_TYPES } from "./shared/utils/permissions";

const ProtectedRoute = ({ children, requiredPermission }) => {
  const loggedIn = useSelector(getIsAuthenticated);
  const accountType = useSelector(getAccountType);

  if (!loggedIn) {
    return <Navigate to="/login" />;
  }

  if (requiredPermission && !checkPermission(accountType, requiredPermission)) {
    return <Navigate to="/planner" />;
  }

  return children;
};

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Navigate to="/planner" replace />} />
        <Route
          path="/planner"
          element={
            <ProtectedRoute requiredPermission={PERMISSION_TYPES.VIEW_EVENTS}>
              <Layout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invite-codes"
          element={
            <ProtectedRoute
              requiredPermission={PERMISSION_TYPES.VIEW_INVITE_CODES}
            >
              <Layout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/students"
          element={
            <ProtectedRoute
              requiredPermission={PERMISSION_TYPES.VIEW_STUDENT_DETAILS}
            >
              <Layout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/explore"
          element={
            <ProtectedRoute
              requiredPermission={PERMISSION_TYPES.VIEW_EXPLORE_STUDENT_DETAILS}
            >
              <Layout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schools"
          element={
            <ProtectedRoute requiredPermission={PERMISSION_TYPES.VIEW_SCHOOLS}>
              <Layout />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/planner" />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
